// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "section{padding:1rem 0;border-bottom:1px solid #dee2e6}section:last-of-type{padding-bottom:0}.sources i,.sources ul{padding-left:1rem}.error{display:flex;flex-direction:column;align-items:center}.error img{height:256px;width:256px}.strike{text-decoration:line-through}.b{font-weight:700}.i{font-style:italic}.super{vertical-align:super;font-size:smaller}img{max-width:1024px}picture img{max-width:300px;max-height:300px;float:right}", ""]);
// Exports
module.exports = exports;
